import { AnyAction, Dispatch } from 'redux';
import { BillingAccount, BillingAccountsActions, BillingAccountsState } from './billing-accounts-models';



const InitialState: BillingAccountsState =
{
	billingAccounts: null,
	billingAccountsLoaded: false,
	currentBillingAccount: null,
	requesting: false,
};



export const billingAccountReducer = (state = InitialState, action: AnyAction): BillingAccountsState => {

	switch (action.type) {

		case BillingAccountsActions.SET_BILLING_ACCOUNTS:
			return {
				...state,
				billingAccounts: action.payload,
				billingAccountsLoaded: true,
				requesting: false,
			};

		case BillingAccountsActions.UNLOAD_BILLING_ACCOUNTS:
			return {
				billingAccounts: null,
				billingAccountsLoaded: false,
				currentBillingAccount: null,
				requesting: false,
			};
		case BillingAccountsActions.SET_CURRENT_BILLING_ACCOUNT:
			return {
				...state,
				currentBillingAccount: action.payload,
			};
		case BillingAccountsActions.BEGIN_BILLING_ACCOUNT_REQUEST:
			return {
				...state,
				requesting: true,
			};
		case BillingAccountsActions.END_BILLING_ACCOUNT_REQUEST:
			return {
				...state,
				requesting: false,
			};

		default: return state;
	}
};

export const setBillingAccounts = (billingAccounts: BillingAccount[]) => {
	return {
		type: BillingAccountsActions.SET_BILLING_ACCOUNTS,
		payload: billingAccounts,
	};
};

export const unloadBillingAccounts = () => {
	return {
		type: BillingAccountsActions.UNLOAD_BILLING_ACCOUNTS,
	};
};

export const setCurrentBillingAccount = (billingAccount: BillingAccount) => {
	return {
		type: BillingAccountsActions.SET_CURRENT_BILLING_ACCOUNT,
		payload: billingAccount,
	};
};

export const beginBillingAccountRequest = () => {
	return {
		type: BillingAccountsActions.BEGIN_BILLING_ACCOUNT_REQUEST,
	};
};

export const endBillingAccountRequest = () => {
	return {
		type: BillingAccountsActions.END_BILLING_ACCOUNT_REQUEST,
	};
};


export const dispatchSetBillingAccount = (dispatch: Dispatch<any>, onSuccess?: (res: any) => void) => (response) => {
	dispatch(setBillingAccounts(response?.data?.billing_accounts));
	if (onSuccess) {
		onSuccess(response?.data?.billing_accounts);
	}
};
